<ng-container *ngrxLet="categoryId$; let categoryId">
  <ng-container *ngrxLet="allCategories$; let allCategories">
    <div class="main-padding">
      <div class="col-md-12 mb-4 mt-4 p-0">
        <app-breadcrumbs
          [items]="getBreadcrumbs(allCategories, categoryId)"
          (itemClick)="goToCategory($event)"
        ></app-breadcrumbs>
      </div>

      <h3>
        {{ activeCategory ? activeCategory.category_title : "All Sports" }}
      </h3>

<!--      <app-result-count>-->
<!--        {{ activeCategory ? "subcategories" : "categories" }}-->
<!--      </app-result-count>-->

      <div
        class="mb-3 mt-3"
        *ngFor="let item of getCategories(categoryId, allCategories)"
      >
        <app-category [category]="item" [wide]="true"></app-category>
      </div>
    </div>
  </ng-container>
</ng-container>
